<section class="hero-section min-vh-100 overflow-hidden position-relative d-flex align-items-center pt-5 pt-md-0">


  <!-- CREAM OVERLAY -->
  <div class="position-absolute top-0 start-0 w-100 h-100 hero-overlay"></div>

  <!-- RIGHT HALF ANGLED PANEL (HIDDEN ON md/sm/xs) -->
  <div class="hero-right-half d-none d-lg-block position-absolute top-0 end-0 h-100"></div>

  <div class="container position-relative hero-content py-5">
    <div class="row align-items-center g-5">

      <!-- LEFT CONTENT -->
      <div class="col-12 col-lg-6">
        <div class="d-inline-flex align-items-center rounded-pill px-4 py-2 text-uppercase fw-semibold text-xs mb-4 hero-pill">
          <span class="me-2 rounded-circle hero-pill-dot"></span>
          {{ hero_data.kicker }}
        </div>

        <h1 class="hero-title fw-semibold lh-1 mb-4">
          <span class="d-block">{{ hero_data.headline }}</span>
          <span class="d-block">{{ hero_data.headline_line_2 }}</span>
          <span class="d-block hero-title-accent fst-italic text-decoration-underline">
            {{ hero_data.headline_accent }}
          </span>
        </h1>

        <p class="hero-lead text-secondary mb-5">
          {{ hero_data.sub_headline }}
        </p>

        <div class="d-flex flex-column flex-sm-row gap-3">
          <router-link
            to="/login"
            class="btn btn-primary text-xs btn-sm text-uppercase fw-light py-2 rounded-3"
          >
            {{ hero_data.btn_text }} <span class="ms-2">→</span>
          </router-link>

          <a
            :href="hero_data.secondary_btn_link"
            class="btn btn-outline-primary text-xs btn-sm text-uppercase fw-light py-2 rounded-3"
          >
            {{ hero_data.demo_text }}
          </a>
        </div>
      </div>

      <!-- RIGHT CONTENT (HIDDEN ON md/sm/xs) -->
      <div class="d-none d-lg-flex col-lg-6 position-relative justify-content-center justify-content-lg-end">
        <div class="card hero-stats-card border-0 text-white rounded-4 overflow-hidden shadow">
          <div class="card-body p-0">
            <div
              v-for="(stat, idx) in hero_stats"
              :key="stat.key"
              class="p-4 text-center hero-stat-row"
              :class="{ 'hero-stat-divider': idx !== hero_stats.length - 1 }"
            >
              <div class="hero-stat-value fw-semibold mb-1">
                {{ stat.value }}
              </div>
              <div class="text-uppercase text-xs text-white-50 fw-semibold">
                {{ stat.label }}
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
